module.exports = __webpack_public_path__ + "img/Maattekening dubbelwerkende cilinder met Gelenkoog.718a46d4.jpg";